class LoadingIndicatorService {
    constructor() {
        this._isLoading = false;
        this._isMasked = false;
        this._message = null;
        this._isMessageSrOnly = true;
    }

    startLoading(isMasked = false, message = null, isMessageSrOnly = true) {
        this._isLoading = true;
        this._isMasked = isMasked;
        this._message = message;
        this._isMessageSrOnly = isMessageSrOnly;
    }

    finishLoading() {
        this._isLoading = false;
        this._isMasked = false;
        this._message = null;
    }
}

module.exports = LoadingIndicatorService;



// WEBPACK FOOTER //
// ./src/common/loadingindicator/loading-indicator.service.js